import React, { Component } from "react";
import "../../src/assests/css/Dashboard.css";

import Sidebar from "./../components/home/Sidebar";

import {
  Container,
  Row,
  Col,
  Card,
  Button,
} from "react-bootstrap";

class DashboardPage extends Component {

  state = {
    sidebarOpen: false,
  };


  // ================= LOGOUT =================
  handleLogout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    window.location.href = "/login";
  };


  // ================= SIDEBAR MOBILE =================
  toggleSidebar = () => {

    this.setState((prevState) => ({
      sidebarOpen: !prevState.sidebarOpen,
    }));

  };


  render() {

    const { sidebarOpen } = this.state;

    return (

      <div className="dashboard-wrapper">


        {/* ================= SIDEBAR ================= */}

        <Sidebar
          sidebarOpen={sidebarOpen}
          toggleSidebar={this.toggleSidebar}
          handleLogout={this.handleLogout}
        />


        {/* ================= MAIN CONTENT ================= */}

        <div className="dashboard-main">


          {/* ================= MOBILE TOP BAR ================= */}

          <div className="mobile-dashboard-header">

            <Button
              className="menu-toggle-btn"
              onClick={this.toggleSidebar}
            >
              ☰
            </Button>


            <h4>Al Saad Rent a Car</h4>


            <div></div>

          </div>


          {/* ================= HEADER ================= */}

          <div className="dashboard-header">

            <Container fluid>

              <div className="dashboard-header-content">

                <div>

                  <h2>Welcome Back 👋</h2>

                  <p>
                    Manage your account and rental activities
                  </p>

                </div>


                <div className="dashboard-header-buttons">

                  <Button className="dashboard-profile-btn">
                    👤 My Profile
                  </Button>


                  <Button
                    className="dashboard-logout-btn"
                    onClick={this.handleLogout}
                  >
                    🚪 Logout
                  </Button>

                </div>

              </div>

            </Container>

          </div>


          {/* ================= DASHBOARD CONTENT ================= */}

          <Container fluid className="dashboard-container">


            {/* ================= STATISTICS ================= */}

            <Row className="g-4">


              {/* TOTAL BOOKINGS */}

              <Col lg={3} md={6} sm={6} xs={12}>

                <Card className="dashboard-stat-card">

                  <div className="stat-icon blue">
                    🚗
                  </div>

                  <div>

                    <h3>12</h3>

                    <p>Total Bookings</p>

                  </div>

                </Card>

              </Col>


              {/* ACTIVE RENTALS */}

              <Col lg={3} md={6} sm={6} xs={12}>

                <Card className="dashboard-stat-card">

                  <div className="stat-icon green">
                    ✓
                  </div>

                  <div>

                    <h3>3</h3>

                    <p>Active Rentals</p>

                  </div>

                </Card>

              </Col>


              {/* PENDING BOOKINGS */}

              <Col lg={3} md={6} sm={6} xs={12}>

                <Card className="dashboard-stat-card">

                  <div className="stat-icon orange">
                    ⏳
                  </div>

                  <div>

                    <h3>2</h3>

                    <p>Pending Bookings</p>

                  </div>

                </Card>

              </Col>


              {/* COMPLETED TRIPS */}

              <Col lg={3} md={6} sm={6} xs={12}>

                <Card className="dashboard-stat-card">

                  <div className="stat-icon red">
                    🏁
                  </div>

                  <div>

                    <h3>7</h3>

                    <p>Completed Trips</p>

                  </div>

                </Card>

              </Col>


            </Row>


            {/* ================= MAIN SECTION ================= */}

            <Row className="g-4 mt-2">


              {/* ================= RECENT BOOKINGS ================= */}

              <Col lg={8} md={12}>

                <Card className="dashboard-card">

                  <Card.Body>


                    <div className="dashboard-card-header">

                      <div>

                        <h4>Recent Bookings</h4>

                        <p>
                          Your latest rental activities
                        </p>

                      </div>


                      <Button className="view-all-btn">
                        View All
                      </Button>

                    </div>


                    {/* BOOKING 1 */}

                    <div className="booking-item">

                      <div className="booking-car-icon">
                        🚘
                      </div>


                      <div className="booking-info">

                        <h5>Toyota Land Cruiser</h5>

                        <span>
                          Booking ID: #ALS-1024
                        </span>

                        <small>
                          📅 25 Aug 2026 – 30 Aug 2026
                        </small>

                      </div>


                      <div className="booking-status active">
                        Active
                      </div>

                    </div>


                    {/* BOOKING 2 */}

                    <div className="booking-item">

                      <div className="booking-car-icon">
                        🚗
                      </div>


                      <div className="booking-info">

                        <h5>Toyota Corolla</h5>

                        <span>
                          Booking ID: #ALS-1023
                        </span>

                        <small>
                          📅 20 Aug 2026 – 24 Aug 2026
                        </small>

                      </div>


                      <div className="booking-status completed">
                        Completed
                      </div>

                    </div>


                  </Card.Body>

                </Card>

              </Col>


              {/* ================= QUICK ACTIONS ================= */}

              <Col lg={4} md={12}>

                <Card className="dashboard-card quick-actions">

                  <Card.Body>

                    <h4>Quick Actions</h4>

                    <p className="quick-subtitle">
                      Quickly access your services
                    </p>


                    <Button className="quick-action-btn">
                      🚗 Browse Cars
                    </Button>


                    <Button className="quick-action-btn">
                      📅 My Bookings
                    </Button>


                    <Button className="quick-action-btn">
                      ❤️ Favourite Cars
                    </Button>


                    <Button className="quick-action-btn">
                      📞 Contact Support
                    </Button>


                  </Card.Body>

                </Card>

              </Col>


            </Row>


          </Container>


        </div>


        {/* ================= MOBILE SIDEBAR OVERLAY ================= */}

        {sidebarOpen && (

          <div
            className="sidebar-overlay"
            onClick={this.toggleSidebar}
          />

        )}


      </div>

    );

  }

}

export default DashboardPage;